import React from "react";
import { Container } from "@mui/material";
import PropTypes from "prop-types";

/**
 * CContainer - A wrapper for MUI Container with additional functionality
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content of the container
 * @param {string} props.maxWidth - Maximum width of the container (xs, sm, md, lg, xl)
 * @param {boolean} props.disableGutters - If true, the left and right padding is removed
 * @param {Object} props.sx - Additional styling for the container
 * @param {Object} props.theme - Theme object for styling
 * @returns {JSX.Element}
 */
const CContainer = ({
  children,
  maxWidth = "lg",
  disableGutters = false,
  sx = {},
  theme,
  ...rest
}) => {
  // Default styles based on theme (if provided)
  const defaultSx = theme
    ? {
        // Add any theme-specific default styling here
      }
    : {};

  return (
    <Container
      maxWidth={maxWidth}
      disableGutters={disableGutters}
      sx={{ ...defaultSx, ...sx }}
      {...rest}
    >
      {children}
    </Container>
  );
};

CContainer.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  disableGutters: PropTypes.bool,
  sx: PropTypes.object,
  theme: PropTypes.object,
};

export default CContainer;